import { Box, FormControl, FormHelperText, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { FC } from 'react';
import { capitalizeFirstLetter } from 'src/utils/text.utils';
import { UnitProps } from 'src/models/FieldProps.interface';
import {
  StyledUnitSelect,
  StyledUnitMenuItem,
  unitSelectMenuProps,
} from 'src/components/StyledComponents/StyledUnitPicker';
import ExpandMoreOutlined from '@mui/icons-material/ExpandMoreOutlined';

const StyledUnitLabel = styled(Typography)`
  font-family: Outfit;
  font-weight: 400;
  font-size: 16px;
  color: var(--primary-navy);
  margin-bottom: 16px;
`;
const StyledFormControl = styled(FormControl)`
  margin: 0;
`;
const StyledChevronIcon = styled(Box)`
  position: absolute;
  top: 50%;
  right: 12px;
  transform: translateY(-50%);
  font-size: 16px;
  color: var(--instructions);
  &:hover {
    cursor: pointer;
  }
`;
const StyledErrorText = styled(FormHelperText)`
  font-family: Outfit;
  font-weight: 400;
  font-size: 14px;
  color: var(--error);
  display: flex;
  align-items: center;
  margin-left: 0;
  margin-top: 8px;
`;
const StyledErrorIcon = styled(Box)`
  font-size: 16px;
  color: var(--error);
  margin-right: 8px;
`;

const UnitField: FC<UnitProps> = ({
  id,
  label,
  formikProps,
  errorState = false,
  height = '40px',
  width = '450px',
  unitList,
}) => {
  const hasError =
    formikProps.touched[id] && (Boolean(formikProps.errors[id]) || errorState);

  return (
    <Box mb={3}>
      <StyledUnitLabel>{label}</StyledUnitLabel>
      <StyledFormControl fullWidth error={hasError}>
        <StyledUnitSelect
          id={id}
          name={id}
          value={formikProps.values[id]}
          onChange={formikProps.handleChange}
          onBlur={formikProps.handleBlur}
          displayEmpty
          height={height}
          width={width}
          hasError={hasError}
          IconComponent={ExpandMoreOutlined}
          renderValue={(selected) =>
            selected
              ? capitalizeFirstLetter(selected as string)
              : `Select ${label}`
          }
          MenuProps={unitSelectMenuProps}
        >
          {unitList.map((unit) => (
            <StyledUnitMenuItem key={unit} value={unit}>
              {unit}
            </StyledUnitMenuItem>
          ))}
        </StyledUnitSelect>
        {formikProps.touched[id] && formikProps.errors[id] && (
          <StyledErrorText>
            <StyledErrorIcon component="i" className="bx bxs-error-circle" />
            {formikProps.errors[id]}
          </StyledErrorText>
        )}
      </StyledFormControl>
    </Box>
  );
};

export default UnitField;
